import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

interface Props {
  title: string
  description?: string
  image: StrapiImageFile
  cta?: StrapiLinkSharedComponent | null
}

function Ecosystem({ title, description, image, cta }: Props): JSX.Element {
  return (
    <section className="font-body bg-blue-web-70 text-white">
      <div className="container | py-10 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-5 text-left">
            <h2
              className={clsx(
                'font-heading text-3xl font-semibold lg:text-5xl tracking-tight',
                description ? 'mb-4 md:mb-10' : ''
              )}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {description ? (
              <div
                className={clsx('text-lg', cta ? 'mb-9' : '')}
                dangerouslySetInnerHTML={{ __html: description }}
              ></div>
            ) : null}
            {cta ? (
              <Link
                href={cta.href}
                className="flex items-center underline underline-offset-8 | mb-14 md:mb-0"
              >
                {cta.title}
              </Link>
            ) : null}
          </div>
          <div className="md:col-start-7 md:col-end-13 relative | m-auto">
            {image ? (
              <Image
                src={image.url}
                alt={image.alternativeText ?? ''}
                width={image.width}
                height={image.height}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Ecosystem
